"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[591],{

/***/ 1591:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6734);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1776);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3906);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7280);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var utils_utils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(8728);
/* harmony import */ var hooks_useTabs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(8083);
/* harmony import */ var hooks_useFetch__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(9350);







const NavigationTab = (param)=>{
    let { path , setPath  } = param;
    const { data: businessProfile  } = (0,hooks_useFetch__WEBPACK_IMPORTED_MODULE_5__/* .useBusinessProfile */ .jB)();
    const profile = businessProfile === null || businessProfile === void 0 ? void 0 : businessProfile.data;
    const calledOnce = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(false);
    const [index, setIndex] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(0);
    const { push , query , locale  } = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    const tabs = (0,hooks_useTabs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)();
    const filteredVisibleTabs = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(()=>{
        return tabs.filter((tab)=>tab.visible);
    }, [
        tabs
    ]);
    const pushUrl = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)((t)=>{
        let _locale = "/".concat(locale, "/");
        if (locale === "default") {
            _locale = "/";
        }
        push({
            pathname: (0,utils_utils__WEBPACK_IMPORTED_MODULE_6__/* .isProd */ .BB)() ? "/b".concat(_locale).concat(profile === null || profile === void 0 ? void 0 : profile.key) : profile === null || profile === void 0 ? void 0 : profile.key,
            query: {
                t
            }
        }, undefined, {
            shallow: true,
            scroll: true
        });
    }, [
        locale,
        profile === null || profile === void 0 ? void 0 : profile.key,
        push
    ]);
    // Get active tab from QueryString
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (calledOnce.current) return;
        if (!query.t) return;
        const tab = tabs.find((menu)=>menu.path === query.t);
        if (tab !== undefined && tab.visible) {
            setPath(tab === null || tab === void 0 ? void 0 : tab.path);
            const _index = filteredVisibleTabs.findIndex((x)=>{
                return x.path === (tab === null || tab === void 0 ? void 0 : tab.path);
            });
            setIndex(_index);
        } else {
            pushUrl("about");
        }
        calledOnce.current = true;
    }, [
        filteredVisibleTabs,
        pushUrl,
        query.t,
        setPath,
        tabs
    ]);
    const onChange = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)((tab, i)=>{
        pushUrl(tab);
        setPath(tab);
        setIndex(i);
    }, [
        pushUrl,
        setPath
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "flex border-b border-zinc-200 scroll-smooth overflow-x-auto scrollbar-hide snap-x relative",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                className: "absolute h-[3px] w-[144px] bg-[#0A202B] rounded-md left-0 bottom-0 transition-transform duration-300",
                style: {
                    transform: "translateX(".concat(144 * index, "px)")
                }
            }),
            filteredVisibleTabs.map((menu, i)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                    type: "button",
                    onClick: ()=>onChange(menu.path, i),
                    "data-test-id": "tab-".concat(menu.path),
                    className: classnames__WEBPACK_IMPORTED_MODULE_3___default()("flex-shrink-0 transition-colors duration-75 uppercase", "ring-0 focus:outline-none focus:ring-0", "select-none", "border-b-2 border-transparent", "py-4", "font-medium text-[#0A202B] text-sm", path === menu.path ? "text-[#0A202B]" : "text-[#848487] hover:text-gray-800"),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: "inline-block w-[144px]",
                        children: menu.label
                    })
                }, menu.id))
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (/*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_1__.memo)(NavigationTab));


/***/ }),

/***/ 8083:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "q": function() { return /* binding */ useMakeLabel; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1776);
/* harmony import */ var hooks_useRender__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3890);
/* harmony import */ var next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8757);
/* harmony import */ var _useFetch__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9350);
/* harmony import */ var utils_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(8728);





const useMakeLabel = function(field) {
    let limit = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 13;
    const { data: businessProfile  } = (0,_useFetch__WEBPACK_IMPORTED_MODULE_3__/* .useBusinessProfile */ .jB)();
    const widgetSetting = businessProfile === null || businessProfile === void 0 ? void 0 : businessProfile.data.widget;
    const { t , lang  } = (0,next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("common");
    // const fieldToSection: any = `${field}s`;
    // const itemsCount = useHowManyItems(fieldToSection);
    const fallbackName = "navigation.".concat(field);
    const titleFromData = (field)=>{
        var _translations_field;
        const translations = widgetSetting === null || widgetSetting === void 0 ? void 0 : widgetSetting.settings.language.translations[lang];
        if (!translations) return null;
        return (_translations_field = translations[field]) === null || _translations_field === void 0 ? void 0 : _translations_field.trimEnd();
    };
    return (0,utils_utils__WEBPACK_IMPORTED_MODULE_4__/* .generateSectionLabel */ .UT)(titleFromData(field), t(fallbackName), limit);
};
const useTabs = ()=>{
    const { t  } = (0,next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("common");
    const isProviderRenderable = (0,hooks_useRender__WEBPACK_IMPORTED_MODULE_1__/* .useCanRender */ .f)("provider");
    const isReviewRenderable = (0,hooks_useRender__WEBPACK_IMPORTED_MODULE_1__/* .useCanRender */ .f)("review");
    const hasProvidersItems = (0,hooks_useRender__WEBPACK_IMPORTED_MODULE_1__/* .useHowManyItems */ ._)("providers") > 0;
    const hasReviewsItems = (0,hooks_useRender__WEBPACK_IMPORTED_MODULE_1__/* .useHowManyItems */ ._)("reviews") > 0;
    const hasServicesItems = (0,hooks_useRender__WEBPACK_IMPORTED_MODULE_1__/* .useHowManyItems */ ._)("services") > 0;
    const providerLabel = useMakeLabel("provider");
    const serviceLabel = useMakeLabel("service");
    const reviewLabel = useMakeLabel("review");
    const tabs = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(()=>{
        return [
            {
                id: 0,
                label: t("navigation.about"),
                path: "about",
                visible: true
            },
            {
                id: 1,
                label: providerLabel,
                path: "providers",
                visible: hasProvidersItems && isProviderRenderable
            },
            {
                id: 2,
                label: serviceLabel,
                path: "services",
                visible: hasServicesItems
            },
            {
                id: 3,
                label: reviewLabel,
                path: "reviews",
                visible: hasReviewsItems && isReviewRenderable
            }
        ];
    }, [
        hasProvidersItems,
        hasReviewsItems,
        hasServicesItems,
        isProviderRenderable,
        isReviewRenderable,
        providerLabel,
        reviewLabel,
        serviceLabel,
        t
    ]);
    return tabs;
};
/* harmony default export */ __webpack_exports__["Z"] = (useTabs);


/***/ }),

/***/ 8728:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BB": function() { return /* binding */ isProd; },
/* harmony export */   "Ee": function() { return /* binding */ generateSocialShare; },
/* harmony export */   "Eh": function() { return /* binding */ toSearchEngineFriendlyWords; },
/* harmony export */   "Hl": function() { return /* binding */ getNameOfDay; },
/* harmony export */   "UT": function() { return /* binding */ generateSectionLabel; },
/* harmony export */   "V5": function() { return /* binding */ formatTime24; },
/* harmony export */   "_2": function() { return /* binding */ generateBookingURL; },
/* harmony export */   "aS": function() { return /* binding */ truncateString; },
/* harmony export */   "dO": function() { return /* binding */ resolvedPublicPath; }
/* harmony export */ });
/* harmony import */ var lodash_es_lowerCase__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7167);
/* harmony import */ var lodash_es_kebabCase__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(194);


const DOMAIN_URL = "https://www.yocale.com";
const getNameOfDay = ()=>{
    const days = [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
    ];
    const d = new Date();
    return days[d.getDay()];
};
const generateBookingURL = (param)=>{
    let { uniqueIdentifier , type , id , locale  } = param;
    let link = "".concat(DOMAIN_URL, "/widget/").concat(uniqueIdentifier, "?lng=").concat(locale);
    switch(type){
        case "location":
            link += "&locations=".concat(id);
            break;
        case "provider":
            link += "&op=~".concat(id);
            break;
        case "service":
            link += "&op=".concat(id, "~");
            break;
        default:
            break;
    }
    return link;
};
const generateSocialShare = (param)=>{
    let { type , businessName , url  } = param;
    let link = "";
    switch(type){
        case "facebook":
            link += "https://facebook.com/sharer/sharer.php?u=".concat(url);
            break;
        case "twitter":
            link += "https://twitter.com/intent/tweet/?text=".concat(businessName, "&url=").concat(url);
            break;
        default:
            break;
    }
    return link;
};
const formatTime24 = (timeString)=>{
    const [hourString, minute] = timeString.split(":");
    const hour = +hourString % 24;
    return (hour % 12 || 12) + ":" + minute + (hour < 12 ? "AM" : "PM");
};
const truncateString = function(str) {
    let num = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 13;
    if (str.length <= num) {
        return str;
    }
    return str.slice(0, num) + "...";
};
const isProd = ()=>"production" === "production";
const resolvedPublicPath = (path)=>isProd() ? "/b/".concat(path) : "/".concat(path);
const toSearchEngineFriendlyWords = (input)=>{
    return encodeURIComponent((0,lodash_es_kebabCase__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)((0,lodash_es_lowerCase__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(input)));
};
const generateSectionLabel = function(label, fallback) {
    let limit = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 13;
    if (!label) return fallback;
    return truncateString(label, limit);
};



/***/ })

}]);